module.exports = __webpack_public_path__ + "assets/chongdian.261430f6.svg";